import sunmiV3Terminal from '@assets/images/sunmi-v3-terminal.png';

const terminalBenefits = [
  {
    title: 'Comandas desde la mesa',
    description: 'Abre mesas, toma pedidos y envíalos a cocina con la PDA de Hosty.',
  },
  {
    title: 'Cobro integrado',
    description: 'Cobra contactless desde el mismo terminal, sin volver a introducir el importe.',
  },
  {
    title: 'Ticket al momento',
    description: 'Impresora térmica integrada para entregar el comprobante al cliente.',
  },
  {
    title: 'Preparado para sala',
    description: 'Formato portátil con batería, Wi-Fi y conectividad móvil para trabajar con libertad.',
  },
];

const terminalSpecs = ['Pantalla táctil de 6,75″', 'NFC y SoftPOS', 'Impresora integrada', 'Wi-Fi y 4G'];

export function SunmiTerminalSection() {
  return (
    <section
      id="terminal-sunmi"
      className="section sunmi-terminal-section"
      aria-labelledby="sunmi-terminal-title"
    >
      <div className="container sunmi-terminal">
        <div className="sunmi-terminal__content">
          <span className="sunmi-terminal__eyebrow">
            <span className="sunmi-terminal__eyebrow-dot" aria-hidden="true" />
            Terminal PDA + cobro
          </span>

          <h2 id="sunmi-terminal-title">Un solo dispositivo para tomar pedidos y cobrar</h2>
          <p className="sunmi-terminal__lead">
            El SUNMI V3 reúne la PDA de Hosty y el cobro con tarjeta en un terminal portátil.
            Atiende la mesa, envía la comanda y completa el pago sin cambiar de dispositivo.
          </p>

          <ul className="sunmi-terminal__benefits">
            {terminalBenefits.map((benefit) => (
              <li key={benefit.title}>
                <span className="sunmi-terminal__check" aria-hidden="true">
                  <svg viewBox="0 0 20 20" fill="none">
                    <path d="m5 10.2 3.1 3.1L15.5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <span>
                  <strong>{benefit.title}</strong>
                  <span>{benefit.description}</span>
                </span>
              </li>
            ))}
          </ul>

          <div className="sunmi-terminal__specs" aria-label="Características del terminal">
            {terminalSpecs.map((spec) => (
              <span key={spec}>{spec}</span>
            ))}
          </div>

          <div className="sunmi-terminal__action">
            <a href="#contacto" className="sunmi-terminal__cta">
              Consultar disponibilidad y comisiones
              <span aria-hidden="true">→</span>
            </a>
            <p>Te facilitamos las condiciones aplicables a tu negocio antes de la contratación.</p>
          </div>
        </div>

        <figure className="sunmi-terminal__media">
          <span className="sunmi-terminal__halo" aria-hidden="true" />
          <img
            src={sunmiV3Terminal}
            alt="Terminal portátil SUNMI V3 con pantalla táctil, NFC e impresora integrada"
            width={3000}
            height={3000}
            loading="lazy"
            decoding="async"
          />
          <figcaption>Modelo mostrado: SUNMI V3.</figcaption>
        </figure>
      </div>
    </section>
  );
}
